import { render, staticRenderFns } from "./FeiXianTu.vue?vue&type=template&id=1f1d9b96&scoped=true&"
import script from "./FeiXianTu.vue?vue&type=script&lang=js&"
export * from "./FeiXianTu.vue?vue&type=script&lang=js&"
import style0 from "./FeiXianTu.vue?vue&type=style&index=0&id=1f1d9b96&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1d9b96",
  null
  
)

export default component.exports